import { createMuiTheme } from "@material-ui/core/styles";

export const lightTheme = createMuiTheme({
  palette: {
    type: "light",
    primary: {
      main: "#F8F8FB",
    },
    secondary: {
      main: "#1217A4",
    },
    card: {
      main: "#FFFFFF",
    },
    text: {
      primary: "#000000",
    },
  },
});

export const darkTheme = createMuiTheme({
  palette: {
    type: "dark",
    primary: {
      main: "#101010",
    },
    secondary: {
      main: "#000000",
    },
    card: {
      main: "#000000",
    },
    text: {
      primary: "#FFFFFF",
    },
  },
});
